/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

export const strings = {
  inputPlaceholderText: 'Start typing a name',
  noResultsFound: `We didn't find any matches.`,
  loadingMessage: 'Loading...',
  suggestedContact: 'suggested contact',
  suggestedContacts: 'suggested contacts',
  selected: 'selected',
  removeSelectedItem: 'remove selected item'
};
